function MyOptions() {
  let calculator = new Calculator2021(CalculatorConfiguration, fundShares)
  let pensionHelper = new PensionHelper(session.pension.secondPillar)

  this.init = function () {
    pensionHelper.redirectIfNotSuspendOrExitIsCancelable()

    const currentSalary = session.pension.currentSalary
    const averageSalary = CalculatorConfiguration.yearlyAverageSalary

    let estimatedPension = calculator.calculate(session.pension, session.pension.thirdPillar.averageMonthlyContribution)

    return {
      retirementAge: Math.floor(session.pension.retirementAge),
      currentSalary: currentSalary || averageSalary,
      estimatedPension: estimatedPension,
      secondPillar: session.pension.secondPillar,
      thirdPillar: session.pension.thirdPillar,
      thirdPillarAvailable: estimatedPension.thirdPillar.monthlyAmount > 0,
      exitedOrSuspended: session.pension.secondPillar.isExitedOrSuspended(),
      suspendCancellationMaxDate: pensionHelper.getSuspendCancellationMaxDate(),
      exitCancellationMaxDate: pensionHelper.getExitCancellationMaxDate(),
    }
  }

  this.done = function (urlParams, args) {
    $('[data-toggle="popover"]').popover({
      animation: false
    })

    let estimatedPension = args.estimatedPension
    new CurrentPensionChart().chart('#current-pension-chart', estimatedPension, args.currentSalary)
    new SuspendPensionChart().chart('#suspend-pension-chart', estimatedPension, args.currentSalary)
    new ExitPensionChart().chart('#exit-pension-chart', estimatedPension, args.currentSalary)
  }
}